export const truncateHtmlIntoString = (htmlString: string, maxLength: number = 130) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  const textContent = doc.body.textContent || '';

  if (textContent.length > maxLength) {
    // Subtract 3 from maxLength to account for the "..." ellipsis
    return textContent.substring(0, maxLength - 3) + '...';
  }
  return textContent;
};
